import { PeriodType } from 'consts/consts';

export default {
    [PeriodType.day]: {
        title: '1 day',
        accessDescription: 'Access today until 23:59',
    },
    [PeriodType.month]: {
        title: '1 month',
        accessDescription: 'Access for 30 days'
    },
    profit: '{{percent}}% savings',
    price: '<atis>{{personal}}\u00a0at. </atis> <gray>/</gray> <rub>{{personal}}\u00a0₽</rub>',
    discountPrice: '<atis>{{personal}} <cross>{{base}}</cross> \u00a0 at. </atis> <gray>/</gray> <rub>{{personal}} <cross>{{base}}</cross>\u00a0₽</rub>',
    discount: 'discount',
};
